import React from "react";
import Layout from "../layout/Layout";
import DemoPages from "../components/demo-iframe/demoPages";

const Demo = () => {
    return (
        <>
            <Layout>
                <DemoPages />
            </Layout>
        </>
    );
};

export default Demo;
